"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tournament_api_1 = require("@l2p/tournament-api");
var prepareBonusType = function (currency, bonus) {
    var _a, _b;
    var reward = (_a = bonus === null || bonus === void 0 ? void 0 : bonus.rewards) === null || _a === void 0 ? void 0 : _a[0];
    var amountItem = (_b = reward === null || reward === void 0 ? void 0 : reward.addedToBalance) === null || _b === void 0 ? void 0 : _b.find(function (item) { return item.currency === currency; });
    return {
        percents: reward === null || reward === void 0 ? void 0 : reward.relativePercent,
        freespins: reward === null || reward === void 0 ? void 0 : reward.freeRoundsCount,
        amount: amountItem
            ? "".concat(amountItem.amount, " ").concat(amountItem.currency)
            : undefined,
    };
};
var getPrizeValue = function (prize, currency, bonuses) {
    var _a, _b;
    var bonus = prize.type === tournament_api_1.TournamentRewardType.Bonus
        ? bonuses.find(function (b) { return b.id === prize.bonusId; })
        : null;
    return {
        amount: prize.type === tournament_api_1.TournamentRewardType.Balance
            ? ((_b = (_a = prize === null || prize === void 0 ? void 0 : prize.amount) === null || _a === void 0 ? void 0 : _a.find(function (item) { return item.currency === currency; })) === null || _b === void 0 ? void 0 : _b.amount) || 0
            : 0,
        freeSpins: prize.type === tournament_api_1.TournamentRewardType.FreeRounds ? prize.value : 0,
        loyaltyExp: prize.type === tournament_api_1.TournamentRewardType.LoyalityExp ? prize.value : 0,
        loyaltyPoints: prize.type === tournament_api_1.TournamentRewardType.LoyalityPoints ? prize.value : 0,
        physicalReward: prize.type === tournament_api_1.TournamentRewardType.Physical ? prize.physicalReward : 0,
        bonus: prize.type === tournament_api_1.TournamentRewardType.Bonus
            ? prepareBonusType(currency, bonus)
            : null,
    };
};
var areValuesEqual = function (a, b) {
    var _a, _b, _c, _d, _e, _f;
    var normalize = function (v) { return parseInt(String(v || 0)); };
    return (normalize(a.amount) === normalize(b.amount) &&
        normalize(a.freeSpins) === normalize(b.freeSpins) &&
        normalize(a.loyaltyExp) === normalize(b.loyaltyExp) &&
        normalize(a.loyaltyPoints) === normalize(b.loyaltyPoints) &&
        normalize(a.physicalReward) === normalize(b.physicalReward) &&
        normalize((_a = a.bonus) === null || _a === void 0 ? void 0 : _a.percents) === normalize((_b = b.bonus) === null || _b === void 0 ? void 0 : _b.percents) &&
        normalize((_c = a.bonus) === null || _c === void 0 ? void 0 : _c.freespins) === normalize((_d = b.bonus) === null || _d === void 0 ? void 0 : _d.freespins) &&
        normalize((_e = a.bonus) === null || _e === void 0 ? void 0 : _e.amount) === normalize((_f = b.bonus) === null || _f === void 0 ? void 0 : _f.amount));
};
var generatePrizeTable = function (_a) {
    var prizes = _a.prizes, currency = _a.currency, bonuses = _a.bonuses, _b = _a.startFrom, startFrom = _b === void 0 ? 1 : _b, _c = _a.asList, asList = _c === void 0 ? false : _c;
    if (!prizes || prizes.length === 0)
        return [];
    if (asList) {
        return prizes.map(function (prize, index) { return ({
            place: startFrom + index,
            value: getPrizeValue(prize, currency, bonuses),
        }); });
    }
    return prizes.reduce(function (acc, prize, idx) {
        var place = idx + startFrom;
        var currentValue = getPrizeValue(prize, currency, bonuses);
        var prevPrize = acc.lastPrize;
        if (!prevPrize || !areValuesEqual(prevPrize.value, currentValue)) {
            acc.result.push({
                place: place,
                value: currentValue,
            });
            acc.lastIndex = acc.result.length - 1;
            acc.lastPrize = { place: place, value: currentValue };
        }
        else {
            var current = acc.result[acc.lastIndex];
            if (typeof current.place === 'number') {
                current.place = "".concat(current.place, "-").concat(place);
            }
            else {
                var parts = String(current.place).split('-');
                current.place = "".concat(parts[0], "-").concat(place);
            }
        }
        return acc;
    }, {
        result: [],
        lastPrize: null,
        lastIndex: -1,
    }).result;
};
exports.default = generatePrizeTable;
